export default __webpack_public_path__ + "static/media/fixing.df64df55.svg";